import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import BigCompanyIcon from "../../../../../media/images/icons/company-big-icon";
import ArrowDownSVG from "../../../../../media/images/icons/arrow-down";
import CopyClipboardIcon from "../../../../../media/images/icons/copy-icon";
import CallSVG from "../../../../../media/images/icons/arrow-steps-register";
import CallOutlineSVG from "../../../../../media/images/icons/call-outline";

export default function CompanyInfoBox() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        backgroundColor: open ? "primary.light" : "info.light",
        paddingX: "16px",
        borderRadius: "16px",
        marginTop: "16px",
        borderWidth: "1px",
        borderColor: "primary.main",
        borderStyle: "solid",
        display: "flex",
        flexDirection: "column",
        paddingY: "8px",
      }}
    >
      <Box
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          // border: "1px solid gray",
          backgroundColor: open ? "primary.main" : "",
          borderRadius: "10px",
          padding: "12px 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          //   border: "1px solid gray",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <BigCompanyIcon
            color={
              open ? theme.palette.primary.light : theme.palette.primary.dark
            }
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                color: open ? "#fff" : "",
              }}
            >
              اطلاعات تماس (مبدا):
            </Typography>

            <Typography
              sx={{
                fontWeight: "600",
                color: open ? "#fff" : "primary.dark",
              }}
            >
              تعاونی حمل و نقل کالا زرند{" "}
            </Typography>
          </Box>
        </Box>
        <ArrowDownSVG
          size={20}
          color={open ? "#fff" : theme.palette.primary.main}
        />
      </Box>
      <Box
        sx={{
          mt: open ? 1 : 0,
          //   boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
          borderRadius: "8px",
          //   backgroundColor: "info.light",
          height: open ? "180px" : "0px",
          paddingY: open ? "8px" : "0px",
          transition: "all 0.3s ease",
          overflow: "hidden",
          paddingX: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              padding: "8px",
              borderRadius: "8px",
              backgroundColor: "background.default",
              //   border: "1px solid gray",
              gap: "8px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <CallOutlineSVG size={15} color={theme.palette.primary.dark} />

                <Typography
                  sx={{
                    color: "primary.dark",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  تلفن شرکت:
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: "info.light",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  padding: "3px",
                  borderRadius: "4px",
                }}
              >
                <CopyClipboardIcon
                  size={20}
                  color={theme.palette.primary.dark}
                />
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "primary.dark",
                  }}
                >
                  کپی
                </Typography>
              </Box>
            </Box>
            <Typography
              noWrap
              sx={{
                fontWeight: "600",
                color: "primary.dark",
              }}
            >
              09999999999 میرزایی‌زاده
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              padding: "8px",
              borderRadius: "8px",
              backgroundColor: "background.default",
              //   border: "1px solid gray",
              gap: "8px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <CallOutlineSVG size={15} color={theme.palette.primary.dark} />

                <Typography
                  sx={{
                    color: "primary.dark",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  تلفن شرکت:
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: "info.light",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  padding: "3px",
                  borderRadius: "4px",
                }}
              >
                <CopyClipboardIcon
                  size={20}
                  color={theme.palette.primary.dark}
                />
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "primary.dark",
                  }}
                >
                  کپی
                </Typography>
              </Box>
            </Box>
            <Typography
              noWrap
              sx={{
                fontWeight: "600",
                color: "primary.dark",
              }}
            >
              09999999999 میرزایی‌زاده
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 1,

            flex: 1,
            padding: "8px",
            borderRadius: "8px",
            backgroundColor: "background.default",
            //   border: "1px solid gray",
            gap: "8px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography>آدرس شرکت:</Typography>
            <Box
              sx={{
                backgroundColor: "#105DAA",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "3px",
                padding: "3px",
                borderRadius: "4px",
              }}
            >
              <CopyClipboardIcon size={20} color="#fff" />
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#fff",
                }}
              >
                کپی آدرس
              </Typography>
            </Box>
          </Box>
          <Typography
            sx={{
              color: "primary.dark",
            }}
          >
            استان فلان، شهرستان فلانک، شهر فلانک،خیابان فلان ، صد متری جاده
            فلان، شهرک صنعتی ، سوله ...
          </Typography>
        </Box>
        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography>کمیته نظارت بر شرکت:</Typography>
          <Box
            sx={{
              backgroundColor: "#105DAA",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "3px",
              padding: "3px",
              borderRadius: "4px",
            }}
          >
            <CopyClipboardIcon size={20} color="#fff" />
            <Typography
              sx={{
                fontSize: "12px",
                color: "#fff",
              }}
            >
              کپی آدرس
            </Typography>
          </Box>
        </Box>
        <Typography
          sx={{
            mt: 1,
            color: "#105DAA",
          }}
        >
          استان فلان، شهرستان فلانک، شهر فلانک، خیابان فلان ، صد متری جاده فلان،
          شهرک صنعتی ، سوله ...
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              paddingX: "4px",
              paddingY: "4px",
              borderRadius: "8px",
              justifyContent: "space-between",
              border: "1px solid gray",
            }}
          >
            <Typography
              sx={{
                color: "#105DAA",
              }}
            >
              09999999999{" "}
            </Typography>
            <Box
              sx={{
                backgroundColor: "#105DAA",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "3px",
                padding: "3px",
                borderRadius: "4px",
              }}
            >
              <CopyClipboardIcon size={20} color="#fff" />
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#fff",
                }}
              >
                کپی
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              paddingX: "4px",
              paddingY: "4px",
              borderRadius: "8px",
              justifyContent: "space-between",
              border: "1px solid gray",
            }}
          >
            <Typography
              sx={{
                color: "#105DAA",
              }}
            >
              09999999999{" "}
            </Typography>
            <Box
              sx={{
                backgroundColor: "#105DAA",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "3px",
                padding: "3px",
                borderRadius: "4px",
              }}
            >
              <CopyClipboardIcon size={20} color="#fff" />
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#fff",
                }}
              >
                کپی
              </Typography>
            </Box>
          </Box>
        </Box> */}
      </Box>
    </Box>
  );
}
